export default __webpack_public_path__ + "static/glassgo_en-272b6238d7c7a6baed5165896695192f.mp3";